import { SceneData, TransitionSceneData } from '../../app-routing';
import BaseScene from './BaseScene';
import { TransitionType, TransitionTypeValues } from '../enums/TransitionType';

export interface TransitionCover {
  show(onComplete?: () => void): void;
  hide(onComplete?: () => void): void;
}

export default class TransitionScene extends BaseScene {
  protected transitionType: TransitionTypeValues;

  constructor(key: string) {
    super(key);

    this.transitionType = TransitionType.SceneToScene;
  }

  public get TransitionType(): TransitionTypeValues {
    return this.transitionType;
  }

  /**
   * Starts a scene to scene to scene transition.
   *
   * source scene -> transition scene -> target scene
   */
  protected beginSceneToSceneTransition(transitionSceneData: TransitionSceneData, transitionCover: TransitionCover, sceneData: any) {
    let targetScene = this.scene.get(transitionSceneData.nextScene);

    this.events.emit(BaseScene.transitionEvents.TransitionCovering);
    transitionCover.show(() => {
      this.events.emit(BaseScene.transitionEvents.TransitionCovered);

      // We need to delay the next transition to the next frame for the game scene or it will trip over itself and kill the scene we just started due to the way gameUI works.
      this.time.delayedCall(1, () => {
        if (targetScene.sys.isSleeping()) targetScene.sys.wake(sceneData);
        else this.scene.manager.start(transitionSceneData.nextScene, sceneData);
      });
    });

    targetScene.events.once(Phaser.Scenes.Events.CREATE, () => {
      this.events.emit(BaseScene.transitionEvents.TransitionUncovering);
      transitionCover.hide();
    });

    // this.events.once(Phaser.Scenes.Events.TRANSITION_COMPLETE, () => {
    //   // We need to delay the next transition to the next frame or it won't fire.
    //   this.time.delayedCall(1, () => {
    //     // Needed as new scenes being added might end up on top and we always want the transition to be top.
    //     // this.scene.bringToTop(this);

    //     this.scene.transition({
    //       target: transitionSceneData.nextScene,
    //       duration: 1000,
    //       // moveBelow: true, // <--- this doesn't work as expected as the target scene will still be on top.
    //       data: sceneData
    //     });

    //     this.time.delayedCall(100, () => {
    //       transitionCover.hide();
    //     });
    //   });
    // });
  }

  /**
   * Starts a scene to scene transition with a second scene as a cover.
   *
   * source scene ---------------------> target scene
   * source scene -> transition cover -> delete cover.
   */
  protected beginSceneCoverTransition(transitionSceneData: TransitionSceneData, transitionCover: TransitionCover) {
    let targetScene = this.scene.get(transitionSceneData.nextScene);

    if (targetScene) {
      targetScene.events.once(Phaser.Scenes.Events.CREATE, () => {
        this.events.emit(BaseScene.transitionEvents.TransitionUncovering);
        transitionCover.hide();
      });
    }

    this.events.emit(BaseScene.transitionEvents.TransitionCovering);
    transitionCover.show(() => {
      this.events.emit(BaseScene.transitionEvents.TransitionCovered);
    });
  }
}
